const Page = (window as any).Page || {};
module.exports = Page;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/tslint-loader!./src/globals/Page.ts